import React from "react";

const Display = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-display"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-display"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m19,2.968l-6,.032v6.419l2.32-2.154c.403-.375,1.037-.354,1.413.053.376.405.352,1.038-.053,1.413l-2.614,2.426c-.561.561-1.307.843-2.057.843-.759,0-1.522-.289-2.103-.869l-2.587-2.4c-.405-.375-.429-1.008-.053-1.413.375-.406,1.009-.428,1.413-.053l2.32,2.153V2.997l-5.973-.008h-.028c-1.33,0-2.581.516-3.525,1.455-.951.945-1.474,2.205-1.474,3.545v6.01c0,2.757,2.243,5,5,5h6v1h-3c-.552,0-1,.448-1,1s.448,1,1,1h8c.552,0,1-.448,1-1s-.448-1-1-1h-3v-1h6c2.757,0,5-2.243,5-5v-6.032c0-2.757-2.243-5-5-5Z" />
    </svg>
  );
};

export default Display;
